import CloseIcon from '@mui/icons-material/Close';
import { Backdrop, Box, Button, Fade, Modal } from '@mui/material';
import PdfUpload2 from '../../../utils/Uploader/PdfUpload2';
import ListInvestorsDetailsComponent from '../investorsDetails/ListInvestorsDetailsComponent';
import ViewInvestor from '../investorsDetails/view/ViewInvestor';
import ViewInwordDividendComponent from '../view/ViewInwardDividendComponent';


const ViewModal = ({ open=false, closeModal, setOpen, selectedDividendId, modalType}) => {
    const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    bgcolor: 'background.paper',
    border: '2px solid #eee',
    boxShadow: '2px 2px 2px 2px #eee',
    borderRadius: "10px",
    p: 4,
  };
  return (
    <>
        <Modal
            open={open}
            onClose={() => setOpen(false)}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{ timeout: 300 }}
            style={{
                overflow: "auto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                scrollbarWidth: "none",
            }}
            >
            <Fade in={open}>
                <Box
                sx={style}
                style={{
                    textAlign: "center",
                    width: "90%",
                    height: "95vh",
                    maxHeight: "95vh",
                    overflow: "auto",
                    scrollbarWidth: "none",
                }}
                >

                {selectedDividendId  && 
                        (
                            modalType === 'view' ?
                            (<ViewInwordDividendComponent
                            id={selectedDividendId}
                            />)
                           
                        :
                         modalType === 'investors_list' ?
                            (<ListInvestorsDetailsComponent
                            id={selectedDividendId}
                            />)
                        :
                        modalType === 'file_upload' ?
                            (<PdfUpload2
                                id={selectedDividendId}
                            />)
                        :
                        modalType === 'details_investor' ?
                            (<ViewInvestor
                                id={selectedDividendId}
                            />)
                        : 
                        null
                        )
                }

                <Button
                    onClick={() => setOpen(false)}
                    variant="contained"
                    color="primary"
                    sx={{ mt: 2 }}
                >
                    <CloseIcon /> Close
                </Button>
                </Box>
            </Fade>
            </Modal>
    </>
  )
}

export default ViewModal